import { ISessionRepository } from "../domain/interfaces/ISessionRepository";
import { ISessionService } from "../domain/interfaces/ISessionService"

const LogoutCurrentSessionUseCase = async (service: ISessionService, values: { localId: string, sessionId: string, registerSessionId: string, operatorId: string }) => {
    return await service.logoutSession(values);
}
export default LogoutCurrentSessionUseCase